import React, { useState } from 'react'
import {
  PanelAccordion,
  SearchForm,
  InputText,
  Group,
  Item,
  Link,
  SpacingVertical,
  Flex
} from 'mailup-web-components'

import ModalSendingSegmentation from 'Components/ModalSendingSegmentation'

import { useIntl } from 'react-intl'
import {
  useRecoilCallback,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState
} from 'recoil'
import {
  manageRecipientsState,
  modalSendingSegmentationState
} from '../recoil/state/manageRecipients'
import { idsState } from '../recoil/state/campaign'
import {
  getQueuedEmailRecipientsCallback,
  sendingSegmentationSimulateCallback
} from '../recoil/callbacks/callbacks'
import TableRecipients from './TableRecipients'

const ManageRecipients = () => {
  const intl = useIntl()

  const [panelCollapsed, setPanelCollapsed] = useState(true)
  const [showTable, setShowTable] = useState(false)
  const { filterBy } = useRecoilValue(manageRecipientsState)
  const setManageRecipientsState = useSetRecoilState(manageRecipientsState)
  const { idAbTest } = useRecoilValue(idsState)
  const getQueuedEmailRecipients = useRecoilCallback(
    getQueuedEmailRecipientsCallback,
    []
  )
  /* modale scelta destinatari */
  const {
    show: showModaleSegmentation,
    error: errorModaleSegmentation,
    severity: severityModaleSegmentation,
    loading: loadingModaleSegmentation,
    groups,
    excludedGroups,
    filters,
    section,
    queued,
    simulationEnabled,
    simulationLoading,
    simulationLoaded,
    simulationResult,
    simulationDiff
  } = useRecoilValue(modalSendingSegmentationState)
  const setModalSegmentationState = useSetRecoilState(
    modalSendingSegmentationState
  )

  const handleSimulate = useRecoilCallback(
    sendingSegmentationSimulateCallback,
    []
  )

  /* ********* */

  const resetManageRecipientsState = useResetRecoilState(manageRecipientsState)

  const handleSearch = () => {
    setShowTable(true)
    getQueuedEmailRecipients()
  }

  const handleReset = () => {
    setShowTable(false)
    resetManageRecipientsState()
  }

  const showModalSegmentation = () => {
    setModalSegmentationState(prev => ({
      ...prev,
      show: true
    }))
  }

  const closeModalSegmentation = () => {
    setModalSegmentationState(prev => ({
      ...prev,
      show: false,
      simulationLoading: false,
      simulationLoaded: false
    }))
  }

  const handleChangeSearchText = e => {
    setManageRecipientsState(prev => ({
      ...prev,
      filterBy: e.target.value
    }))
  }

  return (
    <>
      <ModalSendingSegmentation
        show={showModaleSegmentation}
        error={errorModaleSegmentation}
        severity={severityModaleSegmentation}
        loading={loadingModaleSegmentation}
        groups={groups}
        excludedGroups={excludedGroups}
        filters={filters}
        section={section}
        closeModal={closeModalSegmentation}
        setModalState={setModalSegmentationState}
        queued={queued}
        simulationEnabled={simulationEnabled}
        simulationLoading={simulationLoading}
        simulationLoaded={simulationLoaded}
        simulationResult={simulationResult}
        simulationDiff={simulationDiff}
        handleSimulate={handleSimulate}
      />
      {!idAbTest ||
        (idAbTest <= 0 && (
          <PanelAccordion
            collapsed={panelCollapsed}
            onChange={() => setPanelCollapsed(!panelCollapsed)}
            panelVariant='tertiary'
            title={intl.formatMessage({
              id: 'Load.Queue.ManageRecipients'
            })}
            data-mu-test='email-sending-queue-manage__panel-accordion'
          >
            <SearchForm
              advanced={false}
              labelBtnReset={intl.formatMessage({
                id: 'Load.MailupCommon.Reset'
              })}
              labelBtnSearch={intl.formatMessage({
                id: 'Load.MailupCommon.Search'
              })}
              onClickReset={handleReset}
              onSubmit={handleSearch}
              submitClassName='test-searchButton'
              resetClassName='test-resetButton'
            >
              <Group>
                <Item>
                  <InputText
                    value={filterBy}
                    placeholder={intl.formatMessage({
                      id: 'Load.Queue.FindRecipients'
                    })}
                    onChange={handleChangeSearchText}
                    data-mu-test='email-sending-queue-manage__search-recipient'
                  />
                </Item>
              </Group>
            </SearchForm>
            <SpacingVertical variant='8' />
            <Flex gap='4px'>
              <Link
                variant='extralight'
                data-mu-test='previewMailing-ShowRecipients-click'
                onClick={handleSearch}
              >
                {intl.formatMessage({
                  id: 'Load.Queue.ShowRecipients'
                })}
              </Link>{' '}
              |{' '}
              <Link
                variant='extralight'
                data-mu-test='previewMailing-ShowGroupsAndFiltersApplied-click'
                onClick={showModalSegmentation}
              >
                {intl.formatMessage({
                  id: 'Load.Queue.ShowGroupsAndFilters'
                })}
              </Link>
            </Flex>
            {showTable && (
              <>
                <TableRecipients />
              </>
            )}
          </PanelAccordion>
        ))}
    </>
  )
}

export default ManageRecipients
